/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Proxy_LabelInputs */



/**
* | output |
* | --- |
* | "Proxy" |
*
* @param {Proxy_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const proxy_label = /** @type {((inputs?: Proxy_LabelInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Proxy_LabelInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Proxy")
	if (locale === "es") return /** @type {LocalizedString} */ ("Proxy")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Proxy")
	if (locale === "it") return /** @type {LocalizedString} */ ("Proxy")
	return /** @type {LocalizedString} */ ("Proxy")
});